import React, {useState} from 'react'
import __t from '../../../lib/traduzioni'
import useBSSLogger from '../../../hooks/useBSSLogger'

import { Box, Card, CardActionArea, CardActions, CardContent, CardMedia, IconButton, Divider, Typography, Button, Grid, CircularProgress } from '@mui/material';
import { ArrowForwardIos, Info, Print, PrintDisabled } from '@mui/icons-material'
import Whitespace from '../../Whitespace'
import { useAsyncFn, useDebounce, useInterval } from 'react-use';
import { DefaultSubmitErrorHandler } from "../Preventivo";

import {addizionaleInUso, contestoAggiornato, gestioneErroreRicalcolo, inizializzaQuotazione, labelRitiroConsegna, listaAddizionaliScelti, preventivoMapperLog, svuotaServizi, valoreAddizionaleValido} from './utils/funzioni'
import useStyles from './utils/comparatoreStyle';
import CountDownRitiroInGiornata from './CountDownRitiroInGiornata';
import { useEffect } from 'react';
import { useContext } from 'react';
import BSSPreventivoContext from '../../../contexts/BSSPreventivoContext';
import currencies from '../../../currencies';
import { ricalcolaPreventivi, ricalcolaPreventivo } from '../../../api/estimates';
import {mutate} from 'swr'
import AddizionaliPrezzo from './AddizionaliPrezzo';
import { format } from 'date-fns';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material';
import StatoComparatoreContext from './contexts/StatoComparatore';

const {logger} = useBSSLogger()


const Prezzo = ({preventivo, indicePreventivo, immaginepreventivodefault, onSubmit, setMostraNotePreventivo, dati, valuta}) => {
    
    const theme = useTheme();

    const {methods, addizionaliById, categoriaById} = useContext(StatoComparatoreContext);

    const [erroriRicalcolo, setErroriRicalcolo] = useState({})
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
    const contesto = useContext(BSSPreventivoContext)    
    
    /**
     * 
     * @param {ResPreventivo} preventivo 
     */
    const mostraNote = (preventivo) => {
        setMostraNotePreventivo({
            preventivoSelezionato: preventivo,
            mostra: true
        })
    }

    const ricalcola = async (preventivo, addizionali, suppressErrors = false, svuotaErrori = true) => {

        logger.debug("eseguo ricalcola per ", preventivo, addizionali)

        addizionali = addizionali ?? {};
        
        const req = {
            ...preventivo,
            addizionaliscelti: listaAddizionaliScelti(preventivo, addizionali, methods, addizionaliById)
        };

        try {
            const preventivoaggiornato = await ricalcolaPreventivo(req, suppressErrors);
        
            logger.debug("aggiornamento contesto - prima", contesto.preventivi.quotations.map(preventivoMapperLog));        
            const contestoaggiornato = contestoAggiornato(contesto, preventivoaggiornato, methods)
            logger.debug("aggiornamento contesto - dopo", contestoaggiornato.preventivi.quotations.map(preventivoMapperLog));        


            await mutate("/api/initialDataPreventivo", contestoaggiornato, false)
            
            if(svuotaErrori){
                setErroriRicalcolo({});
            }
            

        } catch(error){

            gestioneErroreRicalcolo(error, preventivo, setErroriRicalcolo, eseguiRicalcolo, suppressErrors)                                    
            
        }
        
    }

    /**
     * Richiama il metodo onSubmit definito in FormPrezzi
     * @param {*} preventivoSelezionato 
     */
    const scegliPreventivo = async (preventivoSelezionato) => {    

        methods.handleSubmit(data => {
            logger.debug("scelto preventivo", preventivoSelezionato, "aggiungo al resto dei dati", data);
            onSubmit({
                ...data,
                preventivoSelezionato
            })
        }, DefaultSubmitErrorHandler)();
    }


    const [{loading: ricalcoloInCorso, value}, eseguiRicalcolo] = useAsyncFn(async (preventivo, addizionali, suppressErrors = false, svuotaErrori = true) => {        
        logger.debug("ricalcolo il preventivo", preventivo, addizionali);
        //const result = await ricalcolaTutti(suppressErrors, svuotaErrori)
        const result = await ricalcola(preventivo, addizionali, suppressErrors, svuotaErrori)
        return result;
    })    


    

    const classes = useStyles();  
    


    const listaaddizionali = (preventivo.listaaddizionali ?? []).filter(
        (addizionale) => !categoriaById[addizionale.categoria.id].categspeciale,
    )

    const labelRitiro = labelRitiroConsegna(preventivo.pickupdate)
    const labelConsegna = labelRitiroConsegna(preventivo.deliverydate)

    useEffect(()=>{
        logger.debug("reinizializzo la quotazione", preventivo.price.id)
        inizializzaQuotazione(contesto, dati, eseguiRicalcolo)   
    }, [])

    
    /**
     * mappa che associa ad ogni preventivo (identificato da id prezzo) la lista degli addizionali scelti
     */
    const addizionaliInUso = dati.reduce((obj, preventivo) => {
        logger.debug("controllo tutti i servizi in uso per il preventivo", preventivo);
        obj[preventivo.price.associazione.prodotto.id] = preventivo.addizionaliscelti ?? [];
        return obj;
    }, {})

    logger.debug("addizionali in uso per preventivo", addizionaliInUso)

    return (
        <>
            <Box my={2}>
                <Card elevation={2}>
                    <div className={classes.root}>
                        <CardMedia
                            className={classes.cover}
                            classes={{
                                img: classes.mobileimg,
                            }}
                            component="img"
                            src={
                                preventivo.pathicon ?? immaginepreventivodefault
                            }
                            onError={(e) =>
                                (e.target.src = immaginepreventivodefault)
                            }
                        />

                        <CardContent
                            className={[
                                classes.content,
                                classes.mainContent,
                            ].join(' ')}
                        >
                            <IconButton className={classes.nonclickable}>
                                {preventivo.printerrequired ? (
                                    <Print
                                        className={classes.addinfoicon}
                                        titleAccess={__t('printrequired')}
                                    />
                                ) : (
                                    <PrintDisabled
                                        className={classes.addinfoicon}
                                        titleAccess={__t('printnotrequired')}
                                    />
                                )}
                            </IconButton>

                            {(preventivo?.note ?? '').length > 0 && (
                                <IconButton
                                    onClick={(e) => mostraNote(preventivo)}
                                >
                                    <Info
                                        className={classes.addinfobtnicon}
                                        titleAccess={__t('noteprodotto')}
                                    />
                                </IconButton>
                            )}

                            <CountDownRitiroInGiornata preventivo={preventivo}>
                                <Divider />
                            </CountDownRitiroInGiornata>

                            <Box pt={0.8}>
                                <b>{preventivo.description}</b>
                                <br />

                                {labelRitiro && (
                                    <>
                                        {__t('primoritiro')}{' '}
                                        <b>
                                            {labelRitiroConsegna(
                                                preventivo.pickupdate,
                                            )}
                                        </b>{' '}
                                    </>
                                )}

                                {preventivo.visualizzadataestesa ? (
                                    <>
                                        {labelConsegna && (
                                            <>
                                                <br />
                                                {__t('conconsegna')}
                                                <Whitespace />
                                                <b>{labelConsegna}</b>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>{preventivo.labeldeliverydate}</>
                                )}
                            </Box>
                        </CardContent>

                        <CardActionArea
                            className={classes.actions}
                            sx={{
                                cursor: !ricalcoloInCorso
                                    ? 'pointer'
                                    : 'not-allowed',
                            }}
                            onClick={(e) =>
                                !ricalcoloInCorso &&
                                scegliPreventivo(preventivo)
                            }
                        >
                            <Box px={1}>
                                <Typography
                                    variant="h4"
                                    paragraph
                                    className={`${classes.price} ${classes.textRight}`}
                                >
                                    {!ricalcoloInCorso ? (
                                        <>
                                            {valuta.symbol}{' '}
                                            {preventivo.totalprice.toFixed(
                                                valuta.decimal_digits,
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <CircularProgress />
                                        </>
                                    )}
                                </Typography>

                                <Typography
                                    variant="subtitle2"
                                    className={`${classes.pricesubtitle} ${classes.textRight}`}
                                >
                                    <pre></pre>
                                    {`${__t('tax')} ${__t(
                                        preventivo.listinoivato === null
                                            ? 'esclusa'
                                            : 'inclusa',
                                    )}`}
                                </Typography>
                            </Box>

                            <CardActions
                                classes={{
                                    root: classes.mobileactions,
                                }}
                            >
                                <Button
                                    color="primary"
                                    variant="contained"
                                    fullWidth
                                    disabled={ricalcoloInCorso}
                                >
                                    <Grid container justify="space-between">
                                        <b>{__t('scegli')} {isMobile && preventivo.description}</b>
                                        <ArrowForwardIos />
                                    </Grid>
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </div>

                    {(listaaddizionali.length ?? 0) > 0 && (
                        <>
                            <Divider />
                            <AddizionaliPrezzo {...{
                                listaaddizionali,  
                                preventivo,                               
                                indicePreventivo,                                 
                                erroriRicalcolo, 
                                setErroriRicalcolo, 
                                eseguiRicalcolo,                                
                            }} />                      
                        </>
                    )}
                </Card>
            </Box>
        </>
    )
}

export default Prezzo
